import * as Cookie from 'js-cookie'
import * as md5 from 'md5'

export const V = 'V'
// Javascript version of PHP uniqid function which is used to
// create the V cookie on chegg.com
export const uniqid = () => {
  const dateMicroseconds = Date.now() / 1000
  let dateString = dateMicroseconds
    .toString(16)
    .split('.')
    .join('')

  while (dateString.length < 14) {
    dateString += '0'
  }

  const randomNumber = Math.random() * 1000
  const randomString = randomNumber.toString()

  return `${md5(randomString)}${dateString}.${Math.floor(
    10000000 + Math.random() * 80000000
  )}`
}

export const getVCookie = () => Cookie.get(V)

export const getOrSetVCookie = (domain: string) => {
  const vCookie = getVCookie()

  if (vCookie) {
    return vCookie
  }

  const vHash = uniqid()

  const date = new Date()

  // V Cookie on chegg.com lasts 10 years
  const expires = new Date(date.getFullYear() + 10, date.getMonth(), date.getDay())
  Cookie.set(V, vHash, {
    domain,
    expires,
    secure: true,
  })

  return vHash
}



// WEBPACK FOOTER //
// ./src/utils/vCookie.ts